import React, { useState, useEffect,useRef,useContext   } from 'react';
import { CONSTANT } from '../../utils/constants';
import { GlobalContext } from '../../utils/GlobalContext';
import { removeInstalizeViewwer, formatNumber } from '../../utils/helpers';


const Header = () => {
    const [colorCodes, setColorCodes] = useState(['#00355D', '#d5b17f']);

    /*For the mobile preview repalce the value and function */
    return (
        <div>
            
            <style>
            {`
              :root {
                --color-theme: ${colorCodes[0]};
                --color-themetwo: ${colorCodes[1]};
              }
              img { 
                max-height: -webkit-fit-content;
              }
              .Icon-Image {
                width: auto;
                height: auto;
              }
              model-viewer {
                width: 100%;
                height: 100%; 
              }
              /* Add other global CSS rules as needed */
            `}
            </style>
        </div>
    );
};

export default Header;
